export const getLogoByLocale = (locale: string | undefined, blackLogo: boolean) => {
  const logoBase = blackLogo ? '/images/black-logo' : '/images/logo'
  if (locale === 'it' || locale === 'de' || locale === 'pt') {
    return `${logoBase}-${locale}.svg`
  }

  return `${logoBase}-en.svg`
}
